<template style="min-width: 1920px;">
	<div id="header" class="detailHeader" >
		<div class="logo" style="cursor: pointer;" @click="toIndex">
			<img class="image" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/logoblack.png">
			<!-- <img class="image" src="../../assets/fImage/logo.png">
			<img class="text" src="../../assets/fImage/logoText.png"> -->
		</div>
		<div class="navbar">
			<div style="margin-top:25px;margin-right: 18%;">
				<div @click="toPhone()" style="float: right;font-size: 12px;color: #98273A;margin-right: 30px;cursor: pointer;"><img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/移动端红.png">移动端</div>
				<!-- <div @click="toAdmin()" style="float: right;font-size: 12px;color: #98273A;margin-right: 30px;cursor: pointer;"><img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/移动端红.png">管理端</div> -->
				<div @click="toEmail()" style="float: right;font-size: 12px;color: #98273A;margin-right: 30px;cursor: pointer;"><img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/邮箱红.png">企业邮箱</div>
				<!-- <div style="float: right;font-size: 12px;color: white;margin-right: 30px;"><img style="width: 15px;height: 15px;vertical-align: middle;margin-right: 4px;" src="../../assets/fImage/邮箱.png">企业邮箱</div> -->
			</div>
			<div style="margin-top: 50px;margin-right: 18%;">
				<el-dropdown v-for="(item,index) in channels" :key="index" placement="bottom-end">
					<el-button :class="['one'+item.id+item.label,item.id == checkId?'check':(item.id == mouseInId?'mouseIn':'')]" :id="'one'+item.id+item.label" type="primary" @click="choseOne(item)" @mouseenter.native="addActive(item)" @mouseleave.native="removeActive(item)">
						{{item.label}}<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu></el-dropdown-menu>
					<el-dropdown-menu style="width:150px;"  slot="dropdown" v-if="item.children && item.children.length > 0">
						<el-dropdown-item style="display:block;" :class="[item2.id+','+item2.label == mouseInItemId?'mouseInItem':'mouseOutItem']" v-for="(item2,index2) in item.children" :key="item2.id+'`'+index2" @click.native="choseTwo(item,item2)"  @mouseenter.native="addActive2(item2)" @mouseleave.native="removeActive2(item2)">{{item2.label}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<!-- <ul class="menu">
				<li>
					<router-link :to="{name:'fIndex'}" tag="span" class="item" active-class="active" exact>首页</router-link>
				</li>
				<li v-for="(item,index) in channels" :key="index">
					<router-link v-if="item.single" :key="item.id" :to='{path:"/channel_detail/"+item.id}' tag="span" class="item" active-class="active">{{item.label}}</router-link>
					<router-link v-else :key="item.id" :to='{path:"/list_detail/"+item.id}' tag="span" class="item" active-class="active">{{item.label}}</router-link> -->
					<!-- <ul class="sub" v-if="item.children">
						<li v-for="(sub,sindex) in item.children" :key="sindex">
							<router-link v-if="sub.single" :to='"/channel_detail/"+sub.id'>{{sub.label}}</router-link>
							<router-link v-else :to='"/list/"+sub.id'>{{sub.label}}</router-link>
						</li>
					</ul> -->
				<!-- </li>
			</ul> -->
			</div>
			
		</div>
	</div>
</template>

<script>
	import {queryByPos,queryIndexByPos} from "../../api/front.js"
	export default {
		name: "FHeader",
		props: {
			checkId: {
				type: Number,
				require: 0
			},
		},
		data() {
			return {
				channels: [{id:0,label:'首页'}],
				// checkId:0,
				mouseInId:null,
				mouseInItemId:null
			}
		},
		mounted() {
			queryIndexByPos('nav').then(data => {
				
				console.log("导航栏2",data.data)
				// this.channels = data.data
				this.channels = this.channels.concat(data.data)
				console.log("导航栏",this.channels)
			}).catch(error => {

			})
		},
		methods:{
			toEmail(){
				window.open('http://mail.hehualawyer.com/', '_blank');
			},
			toIndex(){
				this.$router.push(
					{
						path:'/',
					}
				);
			},
			toPhone(){
				this.$router.push(
					{
						path:'/phoneIndex',
					}
				);
			},
			toAdmin(){
				this.$router.push(
					{
						path:'/adminIndex',
					}
				);
			},
			choseOne(item){
				// if(this.checkId != item.id){
					// this.checkId = item.id
					if(item.id == 0){
						this.$router.push(
							{
								path:'/',
								// query:{a:123456}
							}
						);
					}else if (item.id == 23){
						this.$router.push(
							{
								path:'/aboutUs',
								// query:{a:123456}
							}
						);
					}else if (item.id == 24){
						this.$router.push(
							{
								path:'/hehuaCulture',
							}
						);
					}else if (item.id == 25){
						this.$router.push(
							{
								path:'/businessArea',
							}
						);
					}else if (item.id == 26){
						this.$router.push(
							{
								path:'/professional',
							}
						);
					}else if (item.id == 27){
						this.$router.push(
							{
								path:'/news'
							}
						);
					}else if (item.id == 28){
						this.$router.push(
							{
								path:'/contactUs'
							}
						);
					}
				// }
				

				
				console.log(item)
				console.log(this.checkId)
			},
			choseTwo(item,item2){
				// if(this.checkId != item.id){
					// this.checkId = item.id
					if (item2.id == 29 && item.id != 25){
						this.$router.push(
							{
								path:'/aboutUs',
								// query:{a:123456}
							}
						);
					}else if (item2.id == 30 && item.id != 25){
						this.$router.push(
							{
								path:'/developmentHistory',
								// query:{a:123456}
							}
						);
					}else if (item2.id == 31 && item.id != 25){
						this.$router.push(
							{
								path:'/honoraryAwards',
								// query:{a:123456}
							}
						);
					}else if (item2.id == 32 && item.id != 25){
						this.$router.push(
							{
								path:'/redConstruction',
								// query:{a:123456}
							}
						);
					}else if ((item2.id == 16 || item2.id == 17 || item2.id == 18 || item2.id == 19 || item2.id == 20) && item.id != 25){
						this.$router.push(
							{
								path:'/professional',
								query:{type:item2.id}
							}
						);
					}else if( item.id == 25){
						if(this.checkId == 25){
							this.$parent.changeId(item2.id)
						}else{
							this.$router.push(
								{
									path:'/businessAreaDetail',
									query:{
										id:item2.id
									}
								}
							);
						}
						
					}else if (item2.id == 13){
						this.$router.push(
							{
								path:'/news'
							}
						);
					}else if (item2.id == 14){
						this.$router.push(
							{
								path:'/classicCases'
							}
						);
					}else if (item2.id == 15){
						this.$router.push(
							{
								path:'/professionalArticles'
							}
						);
					}else if (item2.id == 33){
						this.$router.push(
							{
								path:'/contactUs'
							}
						);
					}else if (item2.id == 34){
						this.$router.push(
							{
								path:'/joinUs'
							}
						);
					}
				// }
				console.log(item)
				console.log(item2)
				console.log(this.checkId)
			},
			addActive(item){
				this.mouseInId = item.id
				if(item.id != this.checkId){
					// document.getElementById('one'+item.id+item.label).classList.add("active");
				}
			},
			removeActive(item){
				this.mouseInId = null
				if(item.id != this.checkId){
					// document.getElementById('one'+item.id+item.label).classList.remove("active");
				}
			},
			addActive2(item){
				this.mouseInItemId = item.id+','+item.label
			},
			removeActive2(item){
				this.mouseInItemId = null
			}
		} 
	}
</script>

<style>

</style>
<style lang="scss" scoped>

	.check{
		color: #98273A !important;
    text-decoration: underline;
    text-underline-offset: 8px;
	}
	.detailHeader /deep/ .el-button--primary{
		color: black;
	}
	.mouseOutItem{
		padding-left: 10px !important;
	}

	.mouseInItem{
		padding-left: 10px !important;
    color: #98273A !important;
    background-color: #F2F2F2 !important;
	}

	.mouseIn{
		color: #AA1100;
	}

	.check{
		color: #98273A !important;
    text-decoration: underline;
    text-underline-offset: 8px;
	}

	.navbar /deep/ .el-dropdown-menu{
		width: 150px !important;
	}

	.navbar /deep/ .el-popper{
		width: 150px !important;
	}
	.navbar /deep/ .el-icon--right{
		display: none;
	}
	.navbar /deep/ .el-button--primary{
		background-color: rgba(255, 255, 255, 0);
    border-color: rgba(255, 255, 255, 0);
	}
	ul li {
		padding: 0;
		margin: 0;
		list-style: none;
		display: inline-block;
	}
	#header {
		// position: absolute;
		width: 100% !important;
		border-bottom: 1px solid #F0F0F0;
    // padding: 30px 18%;
		// margin-left: 18%;
		top: 0;
		z-index:5;
		height: 110px;
		width: 100%;
		margin-bottom: 30px;
		background-color: rgba(255,255,255,0.25);
		.logo {
			height: 110px;
			margin-left: 18%;
			display: inline-block;
			float: left;
			.image {
				float: left;
				height: 57px;
				margin: 25px 0;
			}

			.text {
				height: 45px;
				margin: 22.5px 0 12.5px 5px;
			}
		}

		.navbar {
			width:calc(82% - 180px);
			height: 80px;
			text-align: right;
			float: right ;
			display: inline-block;

			.menu {
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: row;
				justify-content: space-between;

				.item {
					display: inline-block;
					height: 40px;
					width: 100px;
					font-size: 20px;
					color: #FFFFFF;
					line-height: 40px;
					text-align: center;
					margin: 20px 20px;
					border-radius: 10px;
				}
				.item:hover {
					cursor: pointer;
				}
				.item {
					&.active {
						background-color: #1A86FF;
						color: #FFFFFF;
					}
				}
			}
		}
	}
</style>
